import {Injectable, signal} from '@angular/core';
import {modalFilePath, modalPath} from "../configs/base-marketing-block-modal-config";

@Injectable({
  providedIn: 'root'
})
export class BaseMarketingBlockPathStateService {
  private _pathState = signal<string>('');
  private _pathFileState = signal<string>('');
  public pathState = this._pathState.asReadonly();
  public pathFileState = this._pathFileState.asReadonly();

  public setPathState(modalKey: string): void {
    this._pathState.set(modalPath[modalKey]);
  }

  public resetPathState(): void {
    this._pathState.set('');
  }

  public setPathFileState(modalKey: string): void {
    this._pathFileState.set(modalFilePath[modalKey]);
  }

  public resetPathFileState(): void {
    this._pathFileState.set('');
  }
}
